var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neo-layout",style:({ width: _vm.layoutWidth, height: _vm.layoutHeight })},[_c('div',{class:[{ 'loading': _vm.loading }, 'neo-layout']},[_vm._t("default")],2),(_vm.loading)?_c('div',{staticClass:"neo-layout__loader"},[(_vm.showLoader)?_c('Loader'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }